module.exports = __webpack_public_path__ + "img/register.6a6f834a.svg";